export const NotReadyRule = {
    "cancelManualCallReprogramed":"cancelManualCallReprogramed",
    "GetAgentID":"GetAgentID",
    "GetCampaignsRelated":"GetCampaignsRelated",
    "getCallHistory":"getCallHistory",
    "getChatHistory":"getChatHistory",
    "GetExtension":"GetExtension",
    "GetUserName":"getUserName",
    "getLastCallData":"getLastCallData",
    "getSupervisorsToChat":"getSupervisorsToChat",
    "Logout":"Logout",
    "makeManualCall":"makeManualCall",
    "sendClientChatMessage":"sendClientChatMessage",
    "setReady":"setReady",
    "setReadyWithPassword":"setReadyWithPassword",
};


// WEBPACK FOOTER //
// ./src/BusinessRule/NotReadyRule.js